'use client'

import { useEffect } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { getFingerprint } from '@marketplace-web/session-management/audit-util'
import {
  landingPageEvent,
  NewAgainLandingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import { NewAgainLandingPageModel } from './types'
import { NewAgainIntroduction } from './components/NewAgainIntroductionSection'
import { NewAgainPotentialSection } from './components/NewAgainPotentialSection/NewAgainPotentialSection'
import { NewAgainForNoweverSection } from './components/NewAgainForNoweverSection'
import { NewAgainFeelNewAgainSection } from './components/NewAgainFeelNewAgainSection'

type Props = { content: NewAgainLandingPageModel }

const NewAgainLandingPage = ({ content }: Props) => {
  const { track } = useTracking()

  useEffect(() => {
    const trackLandingPageView = async () =>
      track(
        landingPageEvent({
          event: NewAgainLandingPageEvent.LandingPageView,
          referrer: document.referrer ? new URL(document.referrer).href : 'unknown',
          deviceId: await getFingerprint(),
        }),
      )

    trackLandingPageView()
  }, [track])

  return (
    <div className="new-again__landing-page-container">
      <NewAgainIntroduction data={content.introduction} />
      <NewAgainPotentialSection data={content.potential} />
      <NewAgainForNoweverSection data={content.forNowever} />
      <NewAgainFeelNewAgainSection data={content.feelNewAgain} />
    </div>
  )
}

export default NewAgainLandingPage
